import axios from "../../axios";

const getProxies = async function (accessToken, params = {}) {
    try {
        const response = await axios.post('proxy/getProxies', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getProxies;

